import DOMPurify from 'dompurify';

const desktopHtml = `
<div class="search-button__wrapper--desktop">
    <button class="c-g-btn__ask-for-help fab-launcher rol-ask-us" title="Open the virtual assistant." aria-label="Ask Us. Opens the virtual assistant">
        <svg viewBox="0 0 45 45" version="1.1" xmlns="http://www.w3.org/2000/svg" role="presentation" aria-hidden="true">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g>
                    <circle cx="22.5" cy="22.5" r="22.5" style="cursor: pointer;"></circle>
                    <g transform="translate(7.309000, 7.933013)">
                        <ellipse stroke="#FFFFFF" stroke-width="2" transform="translate(24.821023, 9.050505) rotate(-30.000000) translate(-24.821023, -9.050505) " cx="24.8210226" cy="9.05050505" rx="6.3450545" ry="6.42503507"></ellipse>
                        <line x1="28.691" y1="14.0669873" x2="32.691" y2="19.0669873" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"></line>
                        <path d="M13.3501982,7.0669873 L4.53097291,7.0669873 C2.41018042,7.0669873 0.691,8.92744149 0.691,11.2224281 L0.691,20.0220753 C0.691,22.3171285 2.41018042,24.1775161 4.53097291,24.1775161 L5.63742248,24.1775161 L5.63742248,27.5475739 C5.63742248,27.8343972 5.85235851,28.0669873 6.11747296,28.0669873 C6.25206196,28.0669873 6.38037095,28.0058916 6.47124622,27.8985577 L9.62337457,24.1775161 L20.8510271,24.1775161 C22.971758,24.1775161 24.691,22.3171285 24.691,20.0220753" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"></path>
                        <circle fill="#5BA63C" cx="8.191" cy="15.5669873" r="1.5"></circle>
                        <circle fill="#5BA63C" cx="12.191" cy="15.5669873" r="1.5"></circle>
                        <circle fill="#5BA63C" cx="16.191" cy="15.5669873" r="1.5"></circle>
                    </g>
                </g>
            </g>
        </svg>
        <span>Ask Us</span>
    </button>
</div>`;

const mobileHtml = `
<div class="search-button__wrapper--mobile">
    <button type="button" class="c-g-btn__ask-for-help fab-launcher rol-ask-us" title="Open the virtual assistant." aria-label="Ask Us. Opens the virtual assistant">
        <svg viewBox="0 0 45 45" version="1.1" xmlns="http://www.w3.org/2000/svg" role="presentation" aria-hidden="true">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g>
                    <circle cx="22.5" cy="22.5" r="22.5" style="cursor: pointer;"></circle>
                    <g transform="translate(7.309000, 7.933013)">
                    <ellipse stroke="#FFFFFF" stroke-width="2" transform="translate(24.821023, 9.050505) rotate(-30.000000) translate(-24.821023, -9.050505) " cx="24.8210226" cy="9.05050505" rx="6.3450545" ry="6.42503507"></ellipse>
                    <line x1="28.691" y1="14.0669873" x2="32.691" y2="19.0669873" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"></line>
                    <path d="M13.3501982,7.0669873 L4.53097291,7.0669873 C2.41018042,7.0669873 0.691,8.92744149 0.691,11.2224281 L0.691,20.0220753 C0.691,22.3171285 2.41018042,24.1775161 4.53097291,24.1775161 L5.63742248,24.1775161 L5.63742248,27.5475739 C5.63742248,27.8343972 5.85235851,28.0669873 6.11747296,28.0669873 C6.25206196,28.0669873 6.38037095,28.0058916 6.47124622,27.8985577 L9.62337457,24.1775161 L20.8510271,24.1775161 C22.971758,24.1775161 24.691,22.3171285 24.691,20.0220753" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" style="cursor: pointer;"></path>
                    <circle fill="#5BA63C" cx="8.191" cy="15.5669873" r="1.5"></circle>
                    <circle fill="#5BA63C" cx="12.191" cy="15.5669873" r="1.5" style="cursor: pointer;"></circle>
                    <circle fill="#5BA63C" cx="16.191" cy="15.5669873" r="1.5"></circle>
                    </g>
                </g>
            </g>
        </svg>
    </button>
</div>
`;


const injectedStyle = `
    #nuanceC2CSearchPhone .search-button__wrapper--mobile {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    @media print, screen and (min-width: 70em) {
        #nuanceC2CSearchPhone .search-button__wrapper--mobile {
            display: none;
        }
    }

    @media print, screen and (max-width: 69.99em) {
        #nuanceC2CSearch .search-button__wrapper--desktop {
            display: none;
        }
    }

    #nuanceC2CSearchPhone .c-g-btn__ask-for-help.fab-launcher.rol-ask-us > * {
        pointer-events: none;
    }

    #nuanceC2CSearch .c-g-btn__ask-for-help.fab-launcher.rol-ask-us > * {
        pointer-events: none;
    }
`;
export default class AskUsInjector {

    static setOnlineBankingButtons() {
        try {
            const host = window.location.host;
            const domain = '.huntington.com';
            if (host.lastIndexOf('onlinebanking', 0) === 0 && host.indexOf(domain, host.length - domain.length) !== -1) {
                const desktopItem = document.getElementById('nuanceC2CSearch');
                if (desktopItem) {
                    desktopItem.innerHTML = DOMPurify.sanitize(desktopHtml);
                }
                const mobileItem = document.getElementById('nuanceC2CSearchPhone');
                if (mobileItem) {
                    mobileItem.innerHTML = DOMPurify.sanitize(mobileHtml);
                }
                const rolHeaderContainer = document.querySelector('header.c-g-header .c-g-header__controls');
                if (rolHeaderContainer) {
                    const style = document.createElement('style');
                    style.textContent = DOMPurify.sanitize(injectedStyle);
                    rolHeaderContainer.append(style);
                }
            }
        }
        catch(e) {
            console.error('Error injecting the ask us buttons', e);
        }
    }
}